import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadSubscribersEpicReducerV2 } from "./LoadSubscribersV2.epics.js";
const subscriberDefaultReducerStateV2 = {
  items: getDefaultAsyncWrapperObj()
};
const subscriberReducerV2 = (state = subscriberDefaultReducerStateV2, action) => {
  state = loadSubscribersEpicReducerV2.reduxChange(state, action);
  return state;
};
const LoadSubscribersReducersMapObjectV2 = {
  subscribersV2: subscriberReducerV2
};
export {
  LoadSubscribersReducersMapObjectV2,
  LoadSubscribersReducersMapObjectV2 as default,
  subscriberDefaultReducerStateV2,
  subscriberReducerV2
};
//# sourceMappingURL=LoadSubscribersV2.ducks.js.map
